import { render, staticRenderFns } from "./TdaInvestmentAccountPage.vue?vue&type=template&id=293bd6be&scoped=true"
import script from "./TdaInvestmentAccountPage.vue?vue&type=script&lang=ts"
export * from "./TdaInvestmentAccountPage.vue?vue&type=script&lang=ts"
import style0 from "./TdaInvestmentAccountPage.vue?vue&type=style&index=0&id=293bd6be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293bd6be",
  null
  
)

export default component.exports